export const homeObjOne = {
    id: 'about',
    topLine: 'Working Out',
    headLine: 'But Whyyyy',
    description: 'Regular physical activity can improve your muscle strength and boost your endurance. Exercise delivers oxygen and nutrients to your tissues and helps your cardiovascular system work more efficiently. And when your heart and lung health improve, you have more energy to tackle daily chores.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: require('../../images/svg-1.svg').default,
    alt: 'workout',
    primary: true,
    
}

